import { QueryConfig } from "store/utils/query-config";

export const proactiveCampaignsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
